// extracted by mini-css-extract-plugin
module.exports = {"heading":"PrivacyPolicyPage_heading__3k7Bz","content":"PrivacyPolicyPage_content__3ZNac"};